// User API
export const sectionClasses = (sectionOptions, blogPost=false) => {
  let classList = `${Object.keys(sectionOptions).map(value => sectionOptions[value]).join(' ')}`
  if(blogPost) {
    classList = classList.replace('pt-32', '')
  }
  return classList

}
